// extracted by mini-css-extract-plugin
module.exports = {"topbar":"topbar_topbar__XNeHf","text":"topbar_text__EYVzE"};